import { FC } from 'react';

interface TextImageSegment {
  id: number;
  text: string;
  textColor: string;
  image?: {
    data: {
      attributes: {
        url: string;
        alternativeText: string;
      };
    };
  };
  imagePosition: 'top' | 'bottom';
}

interface TextWithImagesProps {
  content: {
    TextImageSegment: TextImageSegment[];
  };
}

const getImageUrl = (url: string | undefined) => {
  if (!url) return '';
  return url.startsWith('http')
    ? url
    : process.env.NEXT_PUBLIC_STRAPI_URL
      ? process.env.NEXT_PUBLIC_STRAPI_URL + url
      : url;
};

const TextWithImages: FC<TextWithImagesProps> = ({ content }) => {
  return (
    <div className='mx-auto max-w-4xl px-4 py-8'>
      <div className='flex flex-wrap items-center justify-center gap-2 text-center'>
        {content.TextImageSegment.map((segment) => {
          const imageData = Array.isArray(segment.image?.data)
            ? segment.image.data[0]?.attributes
            : segment.image?.data?.attributes;
          const imageUrl = getImageUrl(imageData?.url);

          return (
            <span key={segment.id} className='inline-flex items-center gap-2'>
              {segment.image &&
                Array.isArray(segment.image.data) &&
                segment.image.data.length > 0 &&
                imageUrl && (
                  <img
                    src={imageUrl}
                    alt={imageData?.alternativeText || ''}
                    style={{
                      height: '5em',
                      width: 'auto',
                      verticalAlign: 'middle',
                    }}
                  />
                )}
              <span
                className='align-middle text-lg font-bold leading-relaxed sm:text-xl md:text-2xl lg:text-3xl'
                style={{
                  color: segment.textColor || '#000000',
                }}
              >
                {segment.text}
              </span>
            </span>
          );
        })}
      </div>
    </div>
  );
};

export default TextWithImages;
